import React, { Component } from 'react'
import Link from '../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { PlayButton } from './icons'

class PropertyAgents extends Component {

  render() {

    let { teamMembers, agents, project } = this.props

    return (

      <section className='property-agents'>

        { agents.map((agent, i) => {
          let el = {}
          if (!project) {
            el = teamMembers.edges.find(item => item.node.info.email === agent.email )
            if (!el?.node) return null
          } else {
            el.node = agent
          }
          return (
            <div className='property-agents__agent' key={i}>
              <div className='property-agents__heading'>
                <p className='agent-name'><Link to={`/team/${el.node.slug}/`}>{ el.node.title }</Link></p>
              </div>
              <div className='property-agents__details'>
                <div className='property-agents__image'>
                  <Link to={`/team/${el.node.slug}/`}>
                    <img src={el.node.info?.thumbnail ? el.node.info.thumbnail : el.node.acf.profileImage.localFile.childImageSharp.original.src} alt={ el.node.info?.firstName } />
                  </Link>
                </div>
                <div className='property-agents__text'>
                  <p className='agent-email'>
                    <Link to={`mailto:${el.node.info?.email ? el.node.info?.email : el.node.acf?.email}`}>Email agent</Link>
                  </p>
                  { el.node.phoneNumbers?.map((em, k) => {
                    if(em.typeCode === "M") {
                      return ( <p className='agent-mobile'><span>M </span><Link to={`tel:${em.number}`}>{ em.number }</Link></p> )
                    }
                  })}
                  { !el.node.phoneNumbers && el.node.acf?.phone &&
                    <p className='agent-mobile'><span>M </span><Link to={`tel:${el.node.acf.phone}`}>{ el.node.acf.phone }</Link></p>
                  }
                </div>
              </div>
            </div>
          )
        })}

      </section>
    )
  }
}

export default PropertyAgents
